'use memo';

import { Link, Outlet, createFileRoute } from '@tanstack/react-router';
import Icon from '@/components/Icon/Icon';
import { VStack } from '@/components/Layout';
import { Text } from '@/components/Typography/Text';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { useSuspenseQueryOperationPackageInstance } from './-queries';
export const Route = createFileRoute('/_stacktrace/qa-operations-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_layout')({
  component: RouteComponent
});

/**
 * テスト計画作成インスタンス詳細のレイアウト。
 *
 * 戻りリンク + パッケージ名を持ち、配下の detail タブを Outlet で描画する。
 * 完了は単一タスクのため、PN「リリース判定」と同様にデータタブは持たず
 * 「詳細」のみの構成とする。
 */
function RouteComponent() {
  const {
    t
  } = useTranslation(stacktraceNS, {
    keyPrefix: 'qaOperationsCore.testPlan.instance'
  });
  const params = Route.useParams();
  const {
    instanceId
  } = params;
  const {
    data: instance
  } = useSuspenseQueryOperationPackageInstance(instanceId);
  return <div className="flex flex-col h-full">
      <VStack className="bg-neutral-fill px-12 pt-4 gap-3">
        <Link to="/qa-operations-core">
          <Icon iconName="ChevronRight" text={t('backToCore')} variant="small" right />
        </Link>
        <Text variant="h4">{instance.name}</Text>
      </VStack>
      <Outlet />
    </div>;
}